// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3310488360": "將文件裝進小程式",
  "4018638528": "微信掃碼體驗",
  "d835ee6e91": "文件已保存<a target=\"_blank\" href=\"//plus.wps.cn/view/media/p/{0}\" style=\"margin-left:10px;color:#417ff9\">查看</a>",
  "a83b7c3d4d": "移動文件成功",
  "ded158d9dc": "文件分享已停止",
  "11377326ac": "請登錄後嘗試訪問",
  "321495498a": "該文件暫不支持在線預覽，請下載查看",
  "6728034eac": "不是本企業成員",
  "c1c0c3ef49": "伺服器錯誤，請稍後重試",
  "94bd113e7c": "文件已損壞，請下載查看",
  "e242d9844d": "文件格式不支持在線播放，請下載查看",
  "7703961444": "轉碼任務超時",
  "85d6dfb01c": "音視頻在線播放權益時長已經使用完畢，請下載查看",
  "aa35fa807c": "本企業音視頻在線播放已被禁用，請聯繫客服",
  "4c5c817619": "作者已刪除該文件",
  "b8b1ab19a3": "加載超時，請稍後重試",
  "69570a01ee": "作者已停止分享該文件",
  "ce6559062c": "文件轉碼中…#{percent}%",
  "05bd98be76": "分享鏈接已關閉",
  "c48dea50b2": "您的操作權限不足",
  "780dc2da0a": "文件可能包含違禁內容，已停止訪問",
  "bdeb76266c": "你沒有該文件的下載權限",
  "f99e7e8772": "該格式文件暫不支持下載",
  "c99e7e8772": "文件正在進行預覽轉換，請稍後重試",
  "f996285100": "播放",
  "ed208c3846": "重新播放",
  "c96a46727b": "暫停",
  "021ad16252": "靜音",
  "c5042be9e1": "取消靜音",
  "aaee2e3006": "全屏",
  "c1e237fdf1": "退出全屏",
  "f1e2762445": "金山文檔",
  "2fd888fd9a": "反饋恢復訪問",
  "800bee819a": "文件分享已停止",
  "bc599ee5cd": "反饋恢復分享",
  "8fe1ecec60": "下載到本地查看",
  "39a641bdc3": "已提交申訴",
  "aed856a076": "本次審核預計48小時內完成，請耐心等待",
  "025e60d871": "進入金山文檔",
  "e385ada474": "文件解封失敗",
  "21805326f1": "文件可能包含違禁內容，可再次申訴",
  "a20c3cecc5": "再次申訴",
  "06bff8a305": "內容不能超過50字",
  "188c4f96ac": "請填寫申訴原因",
  "fba51b188e": "請詳細描述申訴原因",
  "919c36e310": "視頻",
  "46680e2228": "文件轉碼中…",
  "3d86d5e41b": "檔案轉碼中...{0}%",
  "6fb2ee95a6": "正在取得檔案…",
  "447ee65591": "金山文檔",
  "6c4746f45e": "金山文檔",
  "c8ccb36124": "關閉",
  "060897215f": "將文件裝進小程式",
  "d488af2c8e": "微信掃碼體驗",
  "92861a3b7f": " 更新於 ",
  "122ce7bbe9": "分享",
  "8742930fad": "登入",
  "265b2730bd": "分享",
  "40ad48e2e6": "發送到手機",
  "de36f56297": "另存為",
  "88a5eec7a5": "下載",
  "e42de3af08": "返回首頁",
  "bb898f8c35": "舉報文件",
  "ff71e4f8a2": "本地應用程式開啟",
  "cd8cf2f471": "非本企業的音視頻文件不支援線上播放，請下載查看",
  "9cae53c65a": "伺服器錯誤，請稍後重試",
  "a670f3c26a": "企業管理員已禁止當前操作",
  "4cbad45623": "下載",
  "9928443135": "分享",
  "e4f4b9a34d": "另存為",
  "b33f514a94": "幫助與回饋",
  "bb4e26ff65": "舉報文件",
  "b8ed5c2de7": "另存並開啟",
  "e453958fe2": "伺服器錯誤，請稍後重試",
  "79be6d4e4c": "視頻",
  "0354b7ed16": "文件位置：",
  "137c5f6d85": " 更新於 ",
  "d1674c594a": "分享",
  "6a2244a811": "登入",
  "4ec31fbe91": "用WPS開啟",
  "b30f2ea44b": "金山文檔首頁",
  "3314fc385b": "文件",
  "0686b09373": "{0}星標",
  "18eb6b5d58": "取消",
  "8a2a385103": "修改成功",
  "4710fe77f2": "修改失敗",
  "cc0040f6e7": "僅文件所有者才可重命名",
  "fb603598cc": "已設定為星標文件，可快速訪問",
  "b6e981a032": "查看",
  "bfa2986eb3": "取消星標文件",
  "cb5f342bef": "{0}星標文件失敗",
  "0482a30b20": "設定為",
  "d1a3a7b120": "金山文檔",
  "2314ce6081": "作者已設定指定人訪問，請聯絡",
  "241c63f81a": "\n          或登入有權限的帳號\n        ",
  "b573db113b": "作者已設定企業成員訪問，請聯絡",
  "12069886e3": "當前登入帳號 {0}",
  "ced44fd785": "          申請將在30分鐘內處理，請稍後刷新查看\n        ",
  "a8c1a910b2": "申請恢復訪問",
  "d8ffb18522": "下載",
  "6e4e2132b7": "登入",
  "71737deac3": "進入金山文檔",
  "65680083e0": "立即認證",
  "dbc00698ae": "沒有訪問權限",
  "0c01094048": "文件分享已停止",
  "8af9862a91": "文件已刪除",
  "4d74f721f5": "文件不存在",
  "1a9e17476b": "文件已停止訪問",
  "6667a5fc14": "已申請恢復訪問",
  "fdb37ade7f": "金山辦公·一起辦公才高效",
  "dc8e5b3b97": "伺服器錯誤，請稍後重試",
  "11373c971b": "聯絡客服",
  "1b310928e3": " 購買後播放需先通過企業認證\n      ",
  "d4c9ed35b7": "預覽轉換中",
  "5007152f7d": "申請升級套餐",
  "7ae4470de8": "升級套餐",
  "5a50e52115": "購買 {0}，【音視頻播放時長】權益可不限時長使用。",
  "cdc5268c10": "升級套餐可線上預覽音視頻，省去下載等待時間",
  "0e76e21514": "回饋原因",
  "c28bff886a": " (請輸入5-50字)",
  "bfa366d4df": "請詳細描述反饋原因，可加快反饋進度",
  "8c30b9472d": "提交",
  "309ec43078": "反饋",
  "6479ccd94a": "回報原因",
  "fc4e48a17a": " (請輸入5-50個字)",
  "58f69ca425": "請詳細描述反饋原因，可加快反饋進度",
  "7b5fb662cc": "提交",
  "2152682d5d": "該文件暫不支持線上預覽，請下載查看",
  "887322b897": "伺服器錯誤，請稍後重試",
  "27ef615a27": "<p>請聯繫作者</p><p>當前登錄帳號 {0}</p>",
  "5306bedfb4": "聯繫管理員升級企業套餐，開通音視頻線上播放權益",
  "39dba15903": "當前企業套餐不包含音視頻線上播放權益，購買請諮詢：17607563040",
  "c6110c9a54": "非本企業的音視頻文件不支持線上播放，請下載查看",
  "4db4c3dc63": "聯繫管理員完成企業認證，即可使用音視頻線上播放權益",
  "a2368c2d06": "企業未認證，認證通過即可使用音視頻線上播放權益",
  "8bd57619ed": "該文件暫不支援線上預覽，請下載查看",
  "a0f065de59": "伺服器錯誤，請稍後重試",
  "6c9f11f229": "<p>請聯繫作者</p><p>當前登錄帳號 {0}</p>",
  "aaad91aec8": "聯繫管理員升級企業套餐，開通音視頻線上播放權益",
  "f1bd446446": "當前企業套餐不包含音視頻線上播放權益，購買請諮詢：17607563040",
  "22f2a07b81": "非本企業的音視頻文件不支援線上播放，請下載查看",
  "1cd5c90386": "聯繫管理員完成企業認證，即可使用音視頻線上播放權益",
  "a04123abbc": "企業未認證，請進行企業認證（免費）<br/>認證通過即可播放",
  "fdd678fd78": "聯絡客服",
  "471041043d": "「金山文檔」客服QQ號碼",
  "89a75c2d8d": "複製群號碼",
  "1894fcb0c1": "「金山文檔」反饋交流微信群",
  "081814f2bd": "儲存圖片，掃描二維碼進群",
  "26b115245d": "複製成功",
  "f96075a6c8": "當前分享連結已失效",
  "d22b2a0380": "問題已反饋",
  "90446028cc": "點擊回報問題",
  "4ca22157a0": "申訴提交成功",
  "1d3c1de9d7": "申訴提交失敗",
  "4e0e975d62": "唔支援下載",
  "04edf8028f": "冇呢個檔案名稱",
  "1ee5f66661": "提交",
  "c2c0c5ef78": "檔案異常，請檢查後重新上傳"
}